module.exports = __webpack_public_path__ + "static/pine-creek-ec847b02eafae138abbc591f962f7dba.jpg";